import { Injectable, Inject } from '@angular/core';
import { Http, Headers, RequestOptions, Response, RequestMethod } from '@angular/http';
import {Configuration} from '../Shared/Constants/app.constants';
import { Observable }     from 'rxjs/Observable';
// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {TreeModule, TreeNode} from 'primeng/primeng';
import { contentHeaders } from '../Core/Headers';
import { AuthHttp } from 'angular2-jwt';
import { ResponseContentType } from '@angular/http';
import { environment } from '../../environments/environment';


@Injectable()
export class EditKeyTrackerService {

    private headers: Headers;
    private apiUrl: string;
    private actionUrl: string;
    private token: any;
    private readonly APIEndPoint: any = environment.apiEndPoint;

    constructor(private http: Http, private authHttp: AuthHttp) {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');
        this.token = window.localStorage.getItem('id_token');
    }

    saveFieldValue(userID: number, fieldName: string, fieldValue: string){

        this.apiUrl = this.APIEndPoint + '/api/TeamMemberFieldChange/UpdateTeamMemberFieldValue';

        let objEditKey = {
            "UserID": userID
            , "FieldName": fieldName
            , "FieldValue": fieldValue
            , "LoggedInUserID":0
        };

        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let body = JSON.stringify(objEditKey);

        return this.authHttp.post(this.apiUrl, body, options).map(res => {
            return res.json();
        });
    }

    getFieldChangeHistory(userID : number,  fieldName: string) {
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');
        this.apiUrl = this.APIEndPoint + '/api/TeamMemberFieldChange/GetTeamMemberChangeHistory?UserID=' + userID + '&' + 'FieldName=' + fieldName;
        return this.authHttp.get(this.apiUrl, { headers: this.headers }).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/Services/edit-key-tracker.service.ts